export const AnnouncementBar = ({ data }: any) => {
    return (
        <div
            className="py-2 px-4 text-center text-sm font-medium"
            style={{
                backgroundColor: data.backgroundColor || '#000',
                color: data.textColor || '#fff'
            }}
        >
            {data.text || "Welcome to our store!"}
        </div>
    );
};
